 jQuery(document).ready(function($){

	if ($("#background-video").length) {
		var bgvid = $("#background-video").get(0);

		bgvid.onpause = function() {
			document.getElementById("play-pause-copy").innerHTML = "Play";
			if ( $( "#background-video" ).is( ".playing" ) ) {
				$('#background-video').removeClass('playing').addClass('paused');
			}
			if ( $( "#play-pause-button" ).find('i').is( ".fa-pause" ) ) {
				$('#play-pause-button').find('i').removeClass('fa-pause').addClass('fa-play');
			}
		};
		bgvid.onplay = function() {
			document.getElementById("play-pause-copy").innerHTML = "Pause";

			if ( $( "#background-video" ).is( ".paused" ) ) {
				$('#background-video').removeClass('paused').addClass('playing');
			}
			if ( $( "#play-pause-button" ).find('i').is( ".fa-play" ) ) {
				$('#play-pause-button').find('i').removeClass('fa-play').addClass('fa-pause');
			}
		};

		var playpause = document.getElementById("play-pause-button");
		playpause.onclick = function() {
			var bgvid = $("#background-video").get(0);

			if (bgvid.paused) {
				bgvid.play();
			} else {
				bgvid.pause();
			}
		}
	}
});
